import React, { useEffect, useState } from 'react';
import CreateChannel from './CreateChannel';
import ChannelLedgerList from './ChannelLedgerList';
import { saveChannel } from '../../../services/channel/channel';
import { getChannel } from '../../../services/channel/channel';
import { toast } from "../../../components/AppToast";
import { updateChannel } from '../../../services/channel/channel';
const ChannelMgt = () => {
    const [channels, setChanneldata] = useState()
    const [isCreating, setIsCreating] = useState(false);
    const [activeRecord, setActiveRecord] = useState(null); // view/edit


    const onlyFormVisible = isCreating || !!activeRecord;

    const closeForm = () => {
        setIsCreating(false);
        setActiveRecord(null);
    };

    useEffect(() => {

        fetchChannels();
    }, [])


    const fetchChannels = async () => {
        try {
            const data = await getChannel(); // your API call
            // console.log("getChannel", data);
            setChanneldata(data);
        } catch (err) {
            console.error("Error fetching channels:", err);
        }
    };

 const submitForm = async (formData, id) => {
    try {
        if (id) {
            // UPDATE
            // const data = { id, ...formData };
            const updateRes = await updateChannel(formData,id);

            if (updateRes?.status) {
                toast.success("Channel updated successfully");
                await fetchChannels();
                closeForm();
            } else {
                toast.error("Channel updation failed");
            }
        } else {
            // CREATE
            const result = await saveChannel(formData);
            // console.log(result, "result");

            if (result?.status === 201 || result?.statusText === "Created") {
                toast.success("Channel created successfully");
                await fetchChannels();
                closeForm();
            } else {
                toast.error("Channel creation failed");
            }
        }
    } catch (err) {
        console.error("Submit form error:", err);

        const message =
            err?.response?.data?.message ||
            err?.message ||
            "Something went wrong";

        toast.error(message);
    }
};



    return (


        <div className="card shadow-lg main-card">

            {/* ---------- HEADER ---------- */}
            <div className="card-header bg-secondary text-white d-flex justify-content-between align-items-center">
                <h4 className="mb-0 h6 fw-semibold">
                    {!onlyFormVisible
                        ? "Channel"
                        : isCreating
                            ? "Create Channel "
                            : activeRecord?.mode === "edit"
                                ? "Edit Channel"
                                : "View Channel"}
                </h4>
            </div>


            {/* ---------- BREADCRUMBS ---------- */}
            {onlyFormVisible && (
                <nav
                    aria-label="breadcrumb"
                    className="px-3 py-2 border-bottom bg-light"
                >
                    <ol
                        className="breadcrumb mb-0 align-items-center"
                        style={{ ["--bs-breadcrumb-divider"]: "'/'" }}
                    >
                        <li className="breadcrumb-item">
                            <button
                                type="button"
                                className="btn btn-link p-0 text-decoration-none text-muted"
                                onClick={closeForm}
                            >
                                Channel
                            </button>
                        </li>

                        <li
                            className="breadcrumb-item active fw-semibold text-primary"
                            aria-current="page"
                        >
                            {isCreating
                                ? "Create Channel"
                                : activeRecord?.mode === "edit"
                                    ? "Edit Channel"
                                    : "View Channel"}
                        </li>
                    </ol>
                </nav>
            )}



            <div className="card-body">
                {!onlyFormVisible ? (
                    <ChannelLedgerList
                        channels={channels}
                        onCreateClick={() => setIsCreating(true)}
                        onView={(row) =>
                            setActiveRecord({ mode: "view", data: row })
                        }
                        onEdit={(row) =>
                            setActiveRecord({ mode: "edit", data: row })
                        }
                    />
                ) : (

                    <CreateChannel
                        initialValues={activeRecord?.data || {}}
                        onCancel={closeForm}
                        onSubmit={submitForm}
                        viewOnly={activeRecord?.mode === "view"}
                        isEdit={activeRecord?.mode === "edit"}
                    />


                )}
            </div>
        </div>
    );
};

export default ChannelMgt;
